<template>
  <div class="station-optimiser-stock-alloc-page">

    <div class="mt-2">
      <h2 class="text-muted">Optimiser Stock Status</h2>
    </div>
    
    <div class="station-list-container">
      <div class="station-list">

        <LoadingPanel :loading="loading" :loadingError="loadingError" />
        <StaticDataTable class="static-table-list station-table-med" v-if="!loading && !loadingError">
          <template v-slot:header>
            <tr>
              <th width="18px"> </tH>
              <th>Stock</th>
              <th>Status</th>
              <th>Sheets On Hand</th>
              <th>Allocated Sheets</th>
              <th>Total Panels</th>
              <th>Allocated Panels</th>
              <th>Unallocated Panels</th>
              <th>Actions</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="stockInfo of filteredStockList" :key="stockInfo.stockId">
              <td>
                <i class="fas fa-exclamation-triangle text-warning fa-fw" v-if="stockInfo.panelUnallocatedCount > 0" />
              </td>
              <td>
                {{stockInfo.stockName}}
              </td>
              <td>
                <LabelBadge class="text-uppercase" :labelClass="optimiserStockStatusClass(stockInfo)">{{optimiserStockStatusName(stockInfo)}}</LabelBadge>
              </td>
              <td>{{stockInfo.sheetsAvailable}}</td>
              <td>{{stockInfo.sheetsAllocated}}</td>
              <td>{{stockInfo.totalPanelCount}}</td>
              <td>{{stockInfo.panelAllocatedCount}}</td>
              <td>{{stockInfo.panelUnallocatedCount}}</td>          
              <td>
                <ActionDropMenu>
                  <DropdownMenuItem @click="viewStockLevels(stockInfo)" icon="fa-analytics">View Stock Levels</DropdownMenuItem>
                  <DropdownMenuItem @click="viewUnallocatedPanels(stockInfo)" icon="fa-clipboard-list-check">View Unallocated Panels</DropdownMenuItem>
                  <DropdownMenuItem @click="runOptimiserProcess(stockInfo)" icon="fa-sync-alt">Re-run Optimiser</DropdownMenuItem>
                </ActionDropMenu>
              </td>
            </tr>
          </template>
          <template v-slot:empty v-if="filteredStockList.length == 0">No stock data available</template>
        </StaticDataTable>
      </div>
    </div>

    <div class="station-optimiser-stock-alloc-footer mt-4 row">
      <div class="col-3">
        <StationFilterButton v-model="filterUnallocatedOnly">Unallocated Panels Only</StationFilterButton>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.station-optimiser-stock-alloc-page {
  flex: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items:stretch;
  overflow-x: hidden;
}
</style>


<script>
import _ from 'lodash'

import formMixin from '@/mixins/form'
import StationFilterButton from '@/apps/glass-production-station/src/components/station/stationFilterButton'

import OptimiserUnallocPanelsDialog from '@/apps/glass-production-station/src/views/optimiser/optimiserUnallocPanelsDialog'
import StockLevelDialog from '@/apps/glass-production-station/src/views/stockLevelDialog'

export default {
  name: 'OptimiserStockAllocationPage',
  components: {
    StationFilterButton
  },
  mixins: [formMixin],
  props: {
    productionStage: Object,
    productionStation: Object
  },
  data() {
    return {
      loading: true,
      loadingError: '',
      stockAllocList: [],
      filterUnallocatedOnly: false
    }
  },
  computed: {
    filteredStockList() {
      if(this.filterUnallocatedOnly)
        return this.stockAllocList.filter(stockInfo => stockInfo.panelUnallocatedCount > 0)

      return this.stockAllocList
    }
  },
  created() {
  },
  mounted() {
    this.requestData()

    // Update when schedule gets updated
    this.subscribeEndpoint('/production/sheetschedule', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/production/sheetschedule')
  },
  methods: {
    requestData() {
      this.loadingError = ''

      this.$apiService.glassProductionStationService.getOptimiserStockAllocStats(this.productionStation.id)
      .then(response => {
        
        this.stockAllocList = response.data

        // Calculate warning count (number of unallocated panels)
        var warningCount = this.stockAllocList.reduce((curValue, stockInfo) => curValue + stockInfo.panelUnallocatedCount, 0)
        this.$emit('warningCountUpdated', warningCount)
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
        
      })
      .finally(() => {
        this.loading = false
      })
    },    
    // Page Selected - Called when this allocation page is selected to be shown
    pageSelected() {
      this.requestData()
    },
    viewStockLevels(stockInfo) {
      this.displayModal(StockLevelDialog, {
        stockId: stockInfo.stockId
      })
      .then(() => {
      })
    },
    viewUnallocatedPanels(stockInfo) {
      this.displayModal(OptimiserUnallocPanelsDialog, {
        productionStationId: this.productionStation.id,
        stockName: stockInfo.stockName,
        stockId: stockInfo.stockId
      })
      .then(() => {
      })
    },
    runOptimiserProcess(stockInfo) {
      this.$apiService.glassProductionStationService.startOptimiserBGProcess(this.productionStation.id, { stockId: stockInfo.stockId })
      .then(() => {
        this.successToast('Optimiser Process Requested')
      })
      .catch(err => {
        this.displayNetworkError(err, 'Error starting optimiser process')        
      })
    },
    optimiserStockStatusClass(stockInfo) {
      if(stockInfo.queuePendingCount > 0 && stockInfo.queueProcessingCount == 0)
        return 'label-optimiser-queue-status-pending'
      if(stockInfo.queuePendingCount == 0 && stockInfo.queueProcessingCount > 0)
        return 'label-optimiser-queue-status-processing'

      return 'label-optimiser-queue-status-ready'
    },
    optimiserStockStatusName(stockInfo) {
      if(stockInfo.queuePendingCount > 0 && stockInfo.queueProcessingCount == 0)
        return 'Pending'
      if(stockInfo.queuePendingCount == 0 && stockInfo.queueProcessingCount > 0)
        return 'Processing'

      return 'Ready'
    }
  }
}
</script>